import { ReportColumn } from '../../report.models';

export const SALARY_COLUMNS: ReportColumn[] = [
  { field: 'strPersonnelID', title: 'شماره پرسنلی' },
  { field: 'strFullName', title: 'نام و نام خانوادگی' },
  { field: 'strVehicleNo', title: 'پلاک', format: 'plate' },
  { field: 'strServiceCharge', title: 'ساعت سرویس' },
  { field: 'strMobileDomain_strComment', title: 'حوزه خدمت' },
  { field: 'strGPSType_strComment', title: 'نوع خودرو' },
  { field: 'strPresentTime', title: 'ساعت حضور', summary: 'duration', unit: 'ساعت' },
  { field: 'strOvertime', title: 'اضافه کاری' },
  { field: 'strEncouragOvertime', title: 'اضافه کاری تشویقی' },
  { field: 'fKmInTown', title: 'پیمایش شهری', format: 'number' },
  { field: 'fKmMission', title: 'پیمایش ماموریتی', format: 'number' },
  { field: 'iIncentiveKm', title: 'پیمایش تشویقی', format: 'number' },
  { field: 'fTotalKm', title: 'پیمایش کل', format: 'number', total: true, unit: 'کیلومتر' },
  { field: 'iSalary', title: 'حقوق (ریال)', format: 'number', total: true, unit: 'ریال' },
];

export const SALARY_PRINT_COLUMNS: ReportColumn[] = [
  { field: 'strFullName', title: 'راننده' },
  { field: 'strPersonnelID', title: 'شماره پرسنلی' },
  { field: 'strVehicleNo', title: 'پلاک', format: 'plate' },
  { field: 'strGPSType_strComment', title: 'نوع خودرو' },
  { field: 'strMobileDomain_strComment', title: 'حوزه خدمت' },
  { field: 'strTotalTime', title: 'جمع ساعت', summary: 'duration', unit: 'ساعت' },
  { field: 'fTotalKm', title: 'جمع پیمایش', format: 'number', total: true, unit: 'کیلومتر' },
  { field: 'iSalary', title: 'حقوق (ریال)', format: 'number', total: true, unit: 'ریال' },
];

export const REPAIR_COLUMNS: ReportColumn[] = [
  { field: 'strVehicleNo', title: 'پلاک', format: 'plate' },
  { field: 'strFullName', title: 'نام راننده' },
  { field: 'iYearConstruction', title: 'مدل' },
  { field: 'strMobileDomain_strComment', title: 'حوزه خدمت' },
  { field: 'strMobileType_strComment', title: 'نوع خودرو' },
  { field: 'strGPSType_strComment', title: 'نام خودرو' },
  { field: 'iTotalCost', title: 'سرجمع هزینه (ریال)', format: 'number', total: true, unit: 'ریال' },
];

export const SERVICE_DUE_COLUMNS: ReportColumn[] = [
  { field: 'strVehicleNo', title: 'پلاک', format: 'plate' },
  { field: 'strVIN', title: 'VIN' },
  { field: 'strMobileType_strComment', title: 'نوع خودرو' },
  { field: 'strGPSType_strComment', title: 'مدل' },
  { field: 'strMobileDomain_strComment', title: 'حوزه خدمت' },
  { field: 'strGPSType_strComment', title: 'نام خودرو' },
  { field: 'fLastKM', title: 'کیلومتر فعلی', format: 'number' },
  { field: 'strRepairMaintenanceSubject_strComment', title: 'موضوع' },
  { field: 'strMaintenanceMaturity_strComment', title: 'نوع سررسید' },
  { field: 'strvMaintenanceNextMaturity_strDate', title: 'زمان سررسید' },
  { field: 'ivMaintenanceNextMaturity_iKM', title: 'کیلومتر سررسید', format: 'number' },
];
